import { render } from "./DiscussionPagination.vue?vue&type=template&id=a60e0c94&scoped=true"
import script from "./DiscussionPagination.vue?vue&type=script&lang=js"
export * from "./DiscussionPagination.vue?vue&type=script&lang=js"

import "./DiscussionPagination.vue?vue&type=style&index=0&id=a60e0c94&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60e0c94"]])

export default __exports__